import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PageLayout from "components/layout/PageLayout";
import { selectCurrentUserGuid } from "../../auth/authSlice";
import UsersCatalog from "./components/UsersCatalog";
import { useGetUsersQuery } from "./usersApiSlice";

const Users = () => {
    
    const [t] = useTranslation(["global"])
    const userGuid = useSelector(selectCurrentUserGuid)

    const {
        data: users,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetUsersQuery()

    let content;
    if (isSuccess) {
        content = <UsersCatalog users={users.filter(user=> user.guid != userGuid)} />
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return <PageLayout
        pageTitle={t("entity.users")}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />
}

export default Users